// var textbox = document.querySelector('.top-message-text');
// var text = textbox.textContent;

// textbox.innerHTML = null;

// text.split('').forEach(function (c) {
//   textbox.innerHTML += '<span>'+c+'</span>';
// });



$(".top-message-text").contents().each(function (i, node) {
  // console.log(i)
  if (node.nodeType == 3) {
    var text = node.textContent;
    if(i == 0) {
      $(".top-message-text").empty();
    }
    text.split('').forEach(function (val) {
      $(".top-message-text").append("<span>" + val + "</span>");
      // c.innerHTML += '<span>' + c + '</span>';
    });

  } else {
    $(".top-message-text").append(node);
  }

});